module.exports = __webpack_public_path__ + "static/media/digitalocean.310de8d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/digitalocean.png
// module id = 88
// module chunks = 0